export const BASE_URL = 'BASE_URL';
